import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ConditionsGenerales() {
  return (
    <main>
      <Navbar />
      <article className="pt-28 pb-20 md:pb-28 px-6 md:px-10">
        <div className="max-w-2xl mx-auto">
          {/* Header */}
          <header className="mb-12 md:mb-16">
            <span className="block text-xs font-medium tracking-[0.3em] text-stone-400 uppercase mb-4">Légal</span>
            <h1 className="font-serif-display text-4xl md:text-5xl font-bold text-stone-900 leading-tight">
              Conditions générales
            </h1>
          </header>

          {/* Company info block */}
          <div className="bg-stone-50 rounded-2xl p-6 md:p-8 mb-12">
            <h2 className="text-sm font-semibold text-stone-500 uppercase tracking-widest mb-4" id="entreprise">
              <a href="#entreprise">Informations entreprise</a>
            </h2>
            <dl className="flex flex-col gap-2 text-sm text-stone-700">
              <div><dt className="inline font-medium">Raison sociale&nbsp;:</dt> <dd className="inline">KURTA – Dawid Kurta</dd></div>
              <div><dt className="inline font-medium">Statut&nbsp;:</dt> <dd className="inline">Entrepreneur individuel</dd></div>
              <div><dt className="inline font-medium">SIRET&nbsp;:</dt> <dd className="inline">102 042 504 00013</dd></div>
              <div><dt className="inline font-medium">Adresse&nbsp;:</dt> <dd className="inline">2 Rue Pelleport, 33800 Bordeaux, France</dd></div>
              <div><dt className="inline font-medium">Email&nbsp;:</dt> <dd className="inline"><a href="mailto:daw1dkurta@inbox.eu" className="hover:text-stone-900 underline">daw1dkurta@inbox.eu</a></dd></div>
              <div><dt className="inline font-medium">Activité&nbsp;:</dt> <dd className="inline">74.10Z – Activités spécialisées de design</dd></div>
            </dl>
          </div>

          {/* Sections */}
          <div className="prose-custom flex flex-col gap-10 text-stone-600">
            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="objet">
                <a href="#objet">1. Objet</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Les présentes conditions générales régissent l&apos;utilisation du site internet et les relations entre KURTA (ci-après «&nbsp;le prestataire&nbsp;») et ses clients. En accédant à ce site, vous acceptez sans réserve les présentes conditions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="services">
                <a href="#services">2. Services proposés</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Le site présente les services de <strong>design graphique</strong>, design visuel et conception créative proposés par KURTA. Ces services s&apos;adressent aussi bien aux entreprises qu&apos;aux particuliers.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="propriete">
                <a href="#propriete">3. Propriété intellectuelle</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Tous les contenus présents sur ce site (textes, visuels, logos, etc.) sont protégés par le droit de la propriété intellectuelle. Toute reproduction, même partielle, est interdite sans autorisation préalable écrite de KURTA.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="responsabilite">
                <a href="#responsabilite">4. Limitation de responsabilité</a>
              </h2>
              <p className="text-base leading-[1.8]">
                KURTA s&apos;efforce d&apos;assurer l&apos;exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, KURTA ne saurait être tenu responsable des erreurs ou omissions, ni de l&apos;indisponibilité du site.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="droit-applicable">
                <a href="#droit-applicable">5. Droit applicable</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Les présentes conditions générales sont soumises au droit français. En cas de litige, les tribunaux compétents de Bordeaux seront seuls compétents.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3" id="contact-cgu">
                <a href="#contact-cgu">6. Contact</a>
              </h2>
              <p className="text-base leading-[1.8]">
                Pour toute question relative aux présentes conditions, vous pouvez nous contacter à&nbsp;:{' '}
                <a href="mailto:daw1dkurta@inbox.eu" className="text-stone-900 underline hover:no-underline">
                  daw1dkurta@inbox.eu
                </a>
              </p>
            </section>
          </div>

          <p className="text-xs text-stone-400 mt-12">
            Dernière mise à jour&nbsp;: mars 2026
          </p>
        </div>
      </article>
      <Footer />
    </main>
  );
}